import React from 'react';
import { AreaSVGProps } from '../VehiclePaintMeasurement.types';

/**
 * Komponent SVG dla obszaru B - sedan widok lewy
 */
export const AreaB_Sedan_Left: React.FC<AreaSVGProps> = ({
  fill = '#73C69B',
  stroke = '#73C69B',
  strokeWidth = 2,
  fillOpacity = 0.5,
  className = '',
}) => {
  return (
    <svg
      width="107"
      height="156"
      viewBox="0 0 107 156"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <defs>
        <filter
          id="filter_area_b_sedan_left"
          x="0"
          y="0"
          width="107"
          height="156"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
      </defs>

      <g filter="url(#filter_area_b_sedan_left)">
        <path
          d="M39.9722 0.971455C51.821 0.00242722 62.744 -0.288566 71.8732 0.312395C81.1229 0.921284 88.0653 2.42197 92.2856 4.71058C92.424 4.78562 92.5665 4.85221 92.7124 4.91008C95.2825 39.2981 98.2325 81.8988 100.415 113.415L100.415 113.419C101.384 127.411 102.202 139.219 102.768 147.152C101.279 146.759 99.544 146.253 97.5692 145.677C95.8981 145.189 94.0549 144.651 92.0434 144.089C82.3553 141.385 68.012 140.411 53.9169 140.396C39.73 140.38 25.3639 141.339 15.4269 142.68C11.533 143.207 8.71505 143.676 6.6662 144.084C5.77293 95.9779 4.81359 46.4722 4 5.29547C13.8988 3.61933 23.7568 2.29767 39.9722 0.971455Z"
          fill={fill}
          fillOpacity={fillOpacity}
          stroke={stroke}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
          shapeRendering="crispEdges"
        />
      </g>
    </svg>
  );
};
